import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { connect } from 'react-redux';
import { getBulkList, getBulkHistoryList } from 'actions/buyer';
import Bulk from 'components/bulkRequestTable'
import CustomScrollbars from 'util/CustomScrollbars';

function TabContainer({ children, dir, index, value }) {
  return (
    <div dir={dir}>
      {value === index && children}
    </div>
  );
}

const FullWidthTabs = (props) => {
  const [tabValue, setTabValue] = useState(0);
  const [show, setShow] = useState(false);

  const handleChange = (event, value) => {
    setTabValue(value)
    setShow(true)
  };

  useEffect(() => {
    let data = { page: 1, perPage: 50, filter: '' };
    props.getBulkList({ data });
    call();
  }, [])

  const call = () => {
    let data = { page: 1, perPage: 50, filter: '', close: '1' };
    props.getBulkHistoryList({ data });
  }

  const hitApi = () => {
    let data = { page: 1, perPage: 50, filter: '' };
    props.getBulkList({ data });
    call()
  }

  const { bulkList, bulkHistoryList } = props;

  return (
    <div className="w-100" >
      <AppBar position="static" color="default">
        <Tabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="on"
        >
          <Tab className="tab" label="Open" />
          <Tab className="tab" label="History" />
        </Tabs>
      </AppBar>
      <TabContainer dir="ltr" value={tabValue} index={0}>
        <CustomScrollbars className="messages-list scrollbar" style={{ height: 650 }}>
          <Bulk
            orderFromParent={bulkList}
            identifier={'bulkList'}
            hitApi={hitApi}
            show={show}
          />
        </CustomScrollbars>
      </TabContainer>
      <TabContainer dir="ltr" value={tabValue} index={1}>
        <CustomScrollbars className="messages-list scrollbar" style={{ height: 650 }}>
          <Bulk
            orderFromParent={bulkHistoryList}
            identifier={'bulkHistoryList'}
            show={show}
          />
        </CustomScrollbars>
      </TabContainer>
    </div>
  );
}

const mapStateToProps = ({ buyer }) => {
  const { bulkList, bulkHistoryList } = buyer;
  return { bulkList, bulkHistoryList }
};

export default connect(mapStateToProps, { getBulkList, getBulkHistoryList })(FullWidthTabs);